'use es6';

import I18n from 'I18n';
import Features from 'self-service-api/constants/Features';
const SUPPORTED_LANGS = ['en', 'es', 'fr', 'de', 'pt', 'ja', 'nl'];
const CMS_BASE_URL = 'https://f.hubspotusercontent00.net/hubfs/53';

const getImageUrl = extension => CMS_BASE_URL + extension;

const getPlaybooksImages = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';

  if (['en', 'nl'].includes(I18n.lang)) {
    return ['/Paywall/Playbooks-hero-EN.png', '/Playbooks/Playbooks1.png', '/Playbooks/Playbooks2.png', '/Playbooks/Playbooks_Hero.png'].map(getImageUrl);
  }

  return [`/Paywall/Playbooks1-${langToUse.toUpperCase()}.png`, `/Paywall/Playbooks2-${langToUse.toUpperCase()}.png`, `/Paywall/Playbooks3-${langToUse.toUpperCase()}.png`, `/Paywall/Playbooks1-${langToUse.toUpperCase()}.png`].map(getImageUrl);
};

const getSocialImages = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';

  if (['en', 'nl'].includes(I18n.lang)) {
    return [`/Paywall/SocialInbox-hero-EN.png`, '/Screen%20Shot%202018-10-31%20at%206.04.25%20PM.png', '/Screen%20Shot%202018-10-31%20at%206.01.11%20PM.png', '/Social%203.png'].map(getImageUrl);
  }

  return [`/Paywall/SocialInbox-hero-${langToUse.toUpperCase()}.png`, `/Paywall/SocialInbox1-${langToUse.toUpperCase()}.png`, `/Paywall/SocialInbox2-${langToUse.toUpperCase()}.png`, `/Paywall/SocialInbox3-${langToUse.toUpperCase()}.png`].map(getImageUrl);
};

const getSequencesImages = () => {
  const langToUse = SUPPORTED_LANGS.includes(I18n.lang) ? I18n.lang : 'en';

  if (['en', 'nl'].includes(langToUse)) {
    return [`/Paywall/Playbook-and-prospecting/Prospecting-EN.png`, '/SalesAutomation1.png', '/SalesAutomation2.png', '/SalesAutomation3.png'].map(getImageUrl);
  }

  const SEQUENCES_SECOND_IMAGE_SOURCES = {
    pt: '/hubspot.com-new%202020/PT-Inbound-SHE/SalesAutomation2-PT.png',
    ja: '/hubspot.com-new%202020/Japanese-INBOUND-SHE/SalesAutomation2-JA.png',
    de: '/hubspot.com-new%202020/DACH-INBOUND-SHE/SalesAutomation2-DE.png',
    fr: '/hubspot.com-new%202020/FR-Inbound-SHE/SalesAutomation2-FR.png',
    es: '/hubspot.com-new%202020/ES-Inbound-SHE/SalesAutomation2-ES.png'
  };
  return [`/Paywall/Playbook-and-prospecting/Prospecting-${langToUse.toUpperCase()}.png`, `/Paywall/SalesAutomation1-${langToUse.toUpperCase()}.png`, SEQUENCES_SECOND_IMAGE_SOURCES[langToUse], `/Paywall/SalesAutomation3-${langToUse.toUpperCase()}.png`].map(getImageUrl);
};

export const getLocalizedImages = feature => {
  switch (feature) {
    case Features.SOCIAL_MEDIA:
      return getSocialImages();

    case Features.SEQUENCES:
      return getSequencesImages();

    case Features.PLAYBOOKS:
      return getPlaybooksImages();

    default:
      return null;
  }
};